import { render } from "./HitCounterCmp.vue?vue&type=template&id=6825e6d1"
import script from "./HitCounterCmp.vue?vue&type=script&lang=js"
export * from "./HitCounterCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__